import BlockApi from '@/api/api';
import { ErrorObject } from '@/context/CommonDialogContext';
import { CallsRequest } from '@/types/analytics';
import { useMutation } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';
import { useConfig } from './useConfig';
import { useDialogs } from './useDialogs';

export const useAnalytics = () => {
  const auth = useAuth();
  const { config } = useConfig();
  const { showError } = useDialogs();
  const authToken = auth.user?.access_token || '';

  const getDbLogs = useMutation({
    mutationFn: (uuid: string) => BlockApi(config.apiUrl, authToken).analytics.databaseLogs(uuid),
    onError: (error: ErrorObject) => showError({ message: error?.toString() ?? '', stacktrace: error })
  });

  const getAppLogs = useMutation({
    mutationFn: (uuid: string) => BlockApi(config.apiUrl, authToken).analytics.appLogs(uuid),
    onError: (error: ErrorObject) => showError({ message: error?.toString() ?? '', stacktrace: error })
  });

  const getSessionLogs = useMutation({
    mutationFn: (uuid: string) => BlockApi(config.apiUrl, authToken).analytics.traces(uuid),
    onError: (error: ErrorObject) => showError({ message: error?.toString() ?? '', stacktrace: error })
  });

  const getCall = useMutation({
    mutationFn: (uuid: string) => BlockApi(config.apiUrl, authToken).analytics.call(uuid),
    onError: (error: ErrorObject) => showError({ message: error?.toString() ?? '', stacktrace: error })
  });

  const getCallList = useMutation({
    mutationFn: (CallListRequest: CallsRequest) =>
      BlockApi(config.apiUrl, authToken).analytics.callList(CallListRequest),
    onError: (error: ErrorObject) => showError({ message: error?.toString() ?? '', stacktrace: error })
  });

  return { getDbLogs, getAppLogs, getSessionLogs, getCall, getCallList };
};
